window.addEventListener('load', () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('redirect_status') === 'succeeded') {
    window.history.replaceState({}, '', window.location.origin + window.location.pathname);
    document.querySelectorAll('[data-donate-form]').forEach(showSuccess);
    return;
  }
  document.querySelectorAll('[data-donate-form]').forEach(initDonateForm);
});

function showSuccess(form) {
  const amountStep  = form.querySelector('.donate-block__amount-step');
  const paymentStep = form.querySelector('[data-payment-step]');
  const successStep = form.querySelector('[data-success-step]');
  if (amountStep)  amountStep.hidden  = true;
  if (paymentStep) paymentStep.hidden = true;
  if (successStep) successStep.hidden = false;
}

function initDonateForm(form) {
  const amountStep    = form.querySelector('.donate-block__amount-step');
  const paymentStep   = form.querySelector('[data-payment-step]');
  const amountBtns    = form.querySelectorAll('[data-amount]');
  const customInput   = form.querySelector('[data-custom-amount]');
  const proceedBtn    = form.querySelector('[data-proceed-btn]');
  const backBtn       = form.querySelector('[data-back-btn]');
  const selectedLabel = form.querySelector('[data-selected-label]');
  const paymentForm   = form.querySelector('[data-payment-form]');

  let selectedAmount = amountStep.querySelector('.is-active')?.dataset.amount ? parseInt(amountStep.querySelector('.is-active').dataset.amount, 10) : 5;
  let stripe         = null;
  let elements       = null;

  // ── Amount buttons ────────────────────────────────────────────
  amountBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      amountBtns.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      customInput.value = btn.dataset.amount;
      selectedAmount = parseInt(btn.dataset.amount, 10);
    });
  });

  customInput.addEventListener('input', () => {
    amountBtns.forEach((b) => b.classList.remove('is-active'));
    selectedAmount = parseInt(customInput.value, 10) || 0;
  });

  // ── Proceed to payment ────────────────────────────────────────
  proceedBtn.addEventListener('click', async () => {
    if (!selectedAmount || selectedAmount < 1) {
      showError(amountStep, 'Please enter a valid donation amount.');
      return;
    }
    clearError(amountStep);
    setLoading(proceedBtn, true);

    try {
      const res = await fetch(themeVars.stripeApiUrl, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ amount: selectedAmount }),
      });

      const data = await res.json();

      if (!res.ok || !data.client_secret) {
        throw new Error(data.message || 'Could not initialize payment.');
      }

      if (!stripe) {
        stripe = Stripe(themeVars.stripePublicKey); // eslint-disable-line no-undef
      }

      elements = stripe.elements({ clientSecret: data.client_secret });
      const paymentElement = elements.create('payment', {
        layout: 'tabs',
        paymentMethodOrder: ['card', 'google_pay', 'apple_pay', 'us_bank_account'],
      });
      paymentElement.mount('#payment-element');

      selectedLabel.textContent = `$${selectedAmount}`;
      amountStep.hidden = true;
      paymentStep.hidden = false;
    } catch (err) {
      showError(amountStep, err.message);
    } finally {
      setLoading(proceedBtn, false);
    }
  });

  // ── Back ──────────────────────────────────────────────────────
  backBtn.addEventListener('click', () => {
    paymentStep.hidden = true;
    amountStep.hidden  = false;
    document.getElementById('payment-element').innerHTML = '';
    elements = null;
    clearError(paymentForm);
  });

  // ── Submit payment ────────────────────────────────────────────
  paymentForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearError(paymentForm);

    const submitBtn = paymentForm.querySelector('[data-submit-btn]');
    setLoading(submitBtn, true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.origin + window.location.pathname,
      },
      redirect: 'if_required',
    });

    if (error) {
      showError(paymentForm, error.message);
      setLoading(submitBtn, false);
    } else if (paymentIntent && paymentIntent.status === 'succeeded') {
      showSuccess(form);
    }
  });

  // ── Helpers ───────────────────────────────────────────────────
  function setLoading(btn, loading) {
    btn.disabled = loading;
    const spinner = btn.querySelector('[data-btn-spinner]');
    if (spinner) spinner.hidden = !loading;
  }

  function showError(container, msg) {
    const el = container.querySelector('[data-error-msg]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  function clearError(container) {
    const el = container.querySelector('[data-error-msg]');
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }
}
